/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Product_Improvement_LabelInputs */

const en_consent_product_improvement_label = /** @type {(inputs: Consent_Product_Improvement_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I allow Alchema to use pseudonymous, allowlisted usage metadata to improve the product and AI quality.`)
};

const de_consent_product_improvement_label = /** @type {(inputs: Consent_Product_Improvement_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich erlaube Alchema, pseudonyme, auf zugelassene Felder beschränkte Nutzungsmetadaten zur Verbesserung des Produkts und der KI-Qualität zu verwenden.`)
};

const fr_consent_product_improvement_label = /** @type {(inputs: Consent_Product_Improvement_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J’autorise Alchema à utiliser des métadonnées d’usage pseudonymes limitées aux champs autorisés pour améliorer le produit et la qualité de l’IA.`)
};

const es_consent_product_improvement_label = /** @type {(inputs: Consent_Product_Improvement_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permito que Alchema use metadatos de uso seudónimos limitados a campos permitidos para mejorar el producto y la calidad de la IA.`)
};

const it_consent_product_improvement_label = /** @type {(inputs: Consent_Product_Improvement_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consento ad Alchema di usare metadati di utilizzo pseudonimi limitati ai campi consentiti per migliorare il prodotto e la qualità dell’IA.`)
};

const nl_consent_product_improvement_label = /** @type {(inputs: Consent_Product_Improvement_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ik sta Alchema toe gepseudonimiseerde gebruiksmetadata, beperkt tot toegestane velden, te gebruiken om het product en de AI-kwaliteit te verbeteren.`)
};

const pl_consent_product_improvement_label = /** @type {(inputs: Consent_Product_Improvement_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zezwalam Alchema na używanie pseudonimowanych metadanych użytkowania ograniczonych do dozwolonych pól w celu ulepszania produktu i jakości AI.`)
};

const fi_consent_product_improvement_label = /** @type {(inputs: Consent_Product_Improvement_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sallin Alcheman käyttää pseudonyymejä, sallittuihin kenttiin rajattuja käyttötietoja tuotteen ja tekoälyn laadun parantamiseen.`)
};

const da_consent_product_improvement_label = /** @type {(inputs: Consent_Product_Improvement_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeg tillader Alchema at bruge pseudonyme brugsmetadata begrænset til tilladte felter til at forbedre produktet og AI-kvaliteten.`)
};

const sv_consent_product_improvement_label = /** @type {(inputs: Consent_Product_Improvement_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jag tillåter Alchema att använda pseudonyma användningsmetadata begränsade till tillåtna fält för att förbättra produkten och AI-kvaliteten.`)
};

/**
* | output |
* | --- |
* | "I allow Alchema to use pseudonymous, allowlisted usage metadata to improve the product and AI quality." |
*
* @param {Consent_Product_Improvement_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_product_improvement_label = /** @type {((inputs?: Consent_Product_Improvement_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Product_Improvement_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_product_improvement_label(inputs)
	if (locale === "fr") return fr_consent_product_improvement_label(inputs)
	if (locale === "es") return es_consent_product_improvement_label(inputs)
	if (locale === "it") return it_consent_product_improvement_label(inputs)
	if (locale === "nl") return nl_consent_product_improvement_label(inputs)
	if (locale === "pl") return pl_consent_product_improvement_label(inputs)
	if (locale === "fi") return fi_consent_product_improvement_label(inputs)
	if (locale === "da") return da_consent_product_improvement_label(inputs)
	if (locale === "sv") return sv_consent_product_improvement_label(inputs)
	return en_consent_product_improvement_label(inputs)
});